import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import {
  radioGroupLabelStylesSAG,
  radioGroupLabelStylesSHS,
} from './radio-group-label.styles';

@Directive({
  selector: 'label[sag-ui-radio-group-label]',
})
export class RadioGroupLabelDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>
  ) {}

  ngOnInit(): void {
    const radioGroupLabelStyles = componentStylesByTheme(
      this.theme,
      radioGroupLabelStylesSAG,
      radioGroupLabelStylesSHS
    );
    style(this.elementRef, radioGroupLabelStyles());
  }
}
